import Vue from "vue";
import "document-register-element/build/document-register-element";
import vueCustomElement from "vue-custom-element";
import {VueSelect} from "vue-select";

import App from "./App.vue";
Vue.component("v-select", VueSelect);
Vue.use(vueCustomElement);

Vue.customElement("ams-search", App, {
    shadow: true,
    beforeCreateVueInstance(root) {
        const rootNode = root.el.getRootNode();
        const linkEl = document.createElement("link");
        linkEl.setAttribute("rel", "stylesheet");
        // linkEl.setAttribute("href", "/style.min.css");
        linkEl.setAttribute("href", "https://studentpanel.net/widget/dist/style.min.css");
        rootNode.prepend(linkEl);

        if (rootNode instanceof ShadowRoot) {
            root.shadowRoot = rootNode;
        } else {
            root.shadowRoot = document.head;
        }
        return root;
    },
    shadowOptions: {
        mode: "open",
    },
    vueInstanceCreatedCallback() {
        const rootNode = this.shadowRoot;
        rootNode.addEventListener("click", (event) => {
            const targetEl = event.target;

            let TabbedIds = ["TDropCnt", "TDropLbl", "TDropBtn"];
            let VertIds = ["VDropCnt", "VDropLbl", "VDropBtn"];
            let HorizIds = ["HDropCnt", "HDropLbl", "HDropBtn"];

            let isTabbed = TabbedIds.some((id) => event.target.id.includes(id));
            let isVert = VertIds.some((id) => event.target.id.includes(id));
            let isHoriz = HorizIds.some((id) => event.target.id.includes(id));

            if (isTabbed || isVert || isHoriz) {
                if (isTabbed) {
                    rootNode.getElementById("TDrop").classList.toggle("show");
                } else if (isVert) {
                    rootNode.getElementById("VDrop").classList.toggle("show");
                } else if (isHoriz) {
                    rootNode.getElementById("HDrop").classList.toggle("show");
                }
            } else {
                const isCheckbox = targetEl.tagName === "INPUT" && targetEl.type === "checkbox";
                const isChildOfCheckbox = targetEl.closest("input[type='checkbox']") !== null;
                const isDropdownMenuEl = targetEl.classList.contains("form-check-label");

                if (!isCheckbox && !isChildOfCheckbox && !isDropdownMenuEl) {
                    let TDrop = rootNode.getElementById("TDrop");
                    let VDrop = rootNode.getElementById("VDrop");
                    let HDrop = rootNode.getElementById("HDrop");
                    if (TDrop) {
                        TDrop.classList.remove("show");
                    }
                    if (VDrop) {
                        VDrop.classList.remove("show");
                    }
                    if (HDrop) {
                        HDrop.classList.remove("show");
                    }
                }
            }
        });
    },
});
